/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

export enum SettlementDetailAgreementStatusEnum {
    REJECTED = 'Rejected',
    ACCEPTED = 'Accepted'
}
